`use strict`;

var $ = $ || jQuery.noConflict();

(function (jQuery) {

    function draad_form_render(event, form_id, current_page) {

        handle_active_fields(event, form_id, current_page);

    }

    function handle_active_fields(event, form_id, current_page) {

        const inputs = document.querySelectorAll("#gform_wrapper_" + form_id + " input, #gform_wrapper_" + form_id + " textarea");
        inputs.forEach(function (input) {

            const wrap = input.parentNode;
            const label = document.querySelector(`label[for="${input.id}"]`);

            if (!wrap || !label) {
                return;
            }

            if (input.value !== "") {
                wrap.classList.add("--active");
				label.classList.add("--active");
            }

            input.addEventListener("focus", function () {
                const wrap = input.parentNode;
                wrap.classList.add("--active");
				const label = document.querySelector(`label[for="${input.id}"]`);
				label.classList.add("--active");
            });
            input.addEventListener("blur", field_is_active);

        });

    }

    function field_is_active(input) {

        if (!input) {
            return;
        }

        if (input.target) {
            input = input.target;
        }

		const label = document.querySelector(`label[for="${input.id}"]`);
        const wrap = input.parentNode;
        if (!wrap) {
            return;
        }

        if (!input.value) {
            wrap.classList.remove("--active");
			label.classList.remove("--active");
        } else {
            wrap.classList.add("--active");
			label.classList.add("--active");
        }

    }

    $(document).on("gform_post_render", draad_form_render);

})();